import { FC, ReactElement, useMemo } from 'react'

import { TransportationOption } from '../../../entities/TransportationOption/TransportationOption'
import trans from '../../../helpers/trans'
import { SelectOption } from '../../../types'
import { SelectInput } from '../../index'

const generateTransportationOptionOptions = (transportationOptions: TransportationOption[]): SelectOption[] => transportationOptions
    .map(transportationOption => ({ label: transportationOption.name, value: transportationOption.id })) as SelectOption[]

interface TransportationOptionSelectInputProps {
    transportationOptions: TransportationOption[];
    transportationOption: SelectOption | null;
    onChange: (option: SelectOption) => void;
}

const TransportationOptionSelectInput: FC<TransportationOptionSelectInputProps> = ({
    transportationOptions,
    transportationOption,
    onChange,
}): ReactElement => {
    const transportationOptionOptions = useMemo(() => generateTransportationOptionOptions(transportationOptions), [transportationOptions])
    const transportationOptionOptionsWithEmptyValue = [
        { value: '', label: trans('compositions.transportationOptionSelectInput.empty') },
        ...transportationOptionOptions,
    ]

    const onTransportationOptionStateChange = (transportationOptionValue: SelectOption): void => {
        onChange(transportationOptionValue as SelectOption)
    }

    return (
        <SelectInput
            isSearchable={false}
            label={trans('common.transportationOption')}
            name="transportationOption"
            tooltip={trans('compositions.transportationOptionSelectInput.tooltip')}
            value={transportationOption || transportationOptionOptionsWithEmptyValue[0]}
            options={transportationOptionOptionsWithEmptyValue}
            onChange={onTransportationOptionStateChange}
        />
    )
}

export default TransportationOptionSelectInput
